import { Body2InheritStyle, SpacedErrorBanner, SpacedWarningBanner } from '../Styled';
import { PredictiveAudienceGoal, GoalStatus } from '../../types';
import {
  GOAL_NEEDS_REVIEW_DEFAULT,
  SYSTEM_ERROR_BANNER_TITLE,
  SYSTEM_ERROR_BANNER_BODY,
} from '../../constants';
import { ensureString } from '../../utils';

export type ErrorStatusMessageProps = {
  goal: PredictiveAudienceGoal;
};

export const ErrorStatusBanner = (props: ErrorStatusMessageProps) => {
  const { goal } = props;
  if (goal.status === GoalStatus.NEEDS_REVIEW) {
    return (
      <SpacedWarningBanner title={'Needs Review'}>
        <Body2InheritStyle>
          {ensureString(goal.goalValidation?.error_msg, GOAL_NEEDS_REVIEW_DEFAULT)}
        </Body2InheritStyle>
      </SpacedWarningBanner>
    );
  }

  if (goal.status === GoalStatus.SYSTEM_ERROR) {
    return (
      <SpacedErrorBanner title={SYSTEM_ERROR_BANNER_TITLE}>
        <Body2InheritStyle>{SYSTEM_ERROR_BANNER_BODY}</Body2InheritStyle>
      </SpacedErrorBanner>
    );
  }
  return null;
};
